import React from 'react'
import type { ImageProps } from 'antd'

type ImagePreviewConfig = Exclude<ImageProps['preview'], boolean | undefined>
export type ReadonlyPreviewImageRender = NonNullable<
    ImagePreviewConfig['imageRender']
>

export const READONLY_PREVIEW_IMAGE_STYLE: React.CSSProperties = {
    width: 'auto',
    height: 'auto',
    maxWidth: 'calc(100vw - 96px)',
    maxHeight: '70vh',
    objectFit: 'contain',
}

export const buildReadonlyPreviewRender = (
    afterImage?: (
        info: Parameters<ReadonlyPreviewImageRender>[1],
        motionStyle: React.CSSProperties,
    ) => React.ReactNode,
): ReadonlyPreviewImageRender => {
    return (originalNode, info) => {
        const originalStyle =
            (
                originalNode.props as {
                    style?: React.CSSProperties
                }
            ).style || {}
        const motionStyle: React.CSSProperties = {
            transform: originalStyle.transform,
            transitionDuration: '0s',
        }
        const childMotionStyle: React.CSSProperties = {
            transitionDuration: '0s',
        }

        return (
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                    lineHeight: 0,
                    ...motionStyle,
                }}
            >
                {React.cloneElement(originalNode, {
                    style: {
                        ...originalStyle,
                        ...READONLY_PREVIEW_IMAGE_STYLE,
                        transform: undefined,
                        transitionDuration: '0s',
                    },
                } as Partial<React.ComponentProps<'img'>>)}
                {afterImage ? (
                    <div
                        aria-hidden="true"
                        style={{
                            position: 'absolute',
                            inset: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                        }}
                    >
                        {afterImage(info, childMotionStyle)}
                    </div>
                ) : null}
            </div>
        )
    }
}

export const buildReadonlyContainedPreviewRender = (
    afterImage?: (
        info: Parameters<ReadonlyPreviewImageRender>[1],
        motionStyle: React.CSSProperties,
    ) => React.ReactNode,
): ReadonlyPreviewImageRender =>
    buildReadonlyPreviewRender(afterImage)
